export default {
  couponData: {},
  curWatchFun:null,
  trainBannerData: []
}
